module.exports = __webpack_public_path__ + "img/RB_Logo.995275e3.png";